import { createContext, useContext } from "react";

import type {
  CashLocation,
  CashLocationMutationCategory,
} from "~/providers/cash-location-provider";

interface CashLocationContext {
  cashLocations: CashLocation[];
  cashLocationMutationCategories: CashLocationMutationCategory[];
}

export const CashLocationContext = createContext<
  CashLocationContext | undefined
>(undefined);

export const useCashLocation = () => {
  const context = useContext(CashLocationContext);

  if (context === undefined) {
    throw new Error(
      "useCashLocation must be used within a CashLocationProvider, but no provider was found",
    );
  }

  return context;
};
